const e = {
  name: "Linkedin",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M31.7,0H8.3C3.7,0,0,3.7,0,8.3v23.3C0,36.3,3.7,40,8.3,40h23.3c4.6,0,8.3-3.7,8.3-8.3V8.3
			C40,3.7,36.3,0,31.7,0z M13.3,31.7h-5V13.3h5V31.7z M10.8,11.2c-1.6,0-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9
			c1.6,0,2.9,1.3,2.9,2.9C13.7,9.9,12.4,11.2,10.8,11.2z M33.3,31.7h-5v-9.3c0-5.6-6.7-5.2-6.7,0v9.3h-5V13.3h5v3
			c2.3-4.3,11.7-4.6,11.7,4.1V31.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Linkedin
};
